import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from "./components/LoginPage";
import ForgotPassword from "./components/ForgotPassword";
import OTPPage from "./components/OTPPage";
import PasswordReset from "./components/PasswordReset";
import SetNewPassword from "./components/SetNewPassword";
import SuccessfulPage from "./components/SuccessfulPage";
import PetServices from "./components/PetServices";
import ProfileSettings from "./components/ProfileSettings";
import DoctorsPage from "./Screens/DoctorsPage";
import CustomerScreen from "./Screens/CustomerScreen";
import AllDoctorScreen from "./Screens/AllDoctorScreen";
import DoctorProfileScreen from "./components/DoctorProfileScreen";
import AddDoctor from "./components/AddDoctorScreen";
import AppointmentScreen from "./components/AppointmentScreen";
import AppointmentDetailScreen from "./components/AppointmentDetailScreen";
import CustomerDetailScreen from "./components/CustomerDetailScreen";
import SubscriptionPlanScreen from "./components/SubscriptionPlanScreen";
import AddSubscribtion from "./components/AddSubscription";
import ShoppersAndShopScreen from "./components/ShoppersAndShopScreen";
import AddShopScreen from "./components/AddShopScreen";
import ViewProductsScreen from "./components/ViewProductsScreen";
import AddProductScreen from "./components/AddProductScreen";
import ShopDetails from "./components/ShopDetails";
import ProductDetails from "./components/ProductDetails";
import BookingScreen from "./components/BookingScreen";
import OrdersScreen from "./components/OrdersScreen";
import GroomingScreen from "./Screens/GroomingScreen";
import BoardingScreen from "./Screens/BoardingScreen";
import WalkingScreen from "./Screens/WalkingScreen";
import TrainingScreen from "./Screens/TrainingScreen";
import DoctorAppointmentScreen from "./components/DoctorAppointmentScreen";
import DietPlanScreen from "./components/DietPlanScreen";
import AddPackage from "./Screens/AddPackageGrooming";
import BookingDetail from "./components/BookingDetail";
import Dashboard from "./Screens/Dashboard";
import OrderDetailsScreen from "./components/OrderDetailsScreen";
import AppointmentDetailsScreenTwo from "./components/AppointmentDetailsScreenTwo";
import AddWalkingPackage from "./components/AddPackagewalking";
import AddBoardingPackage from "./Screens/AddPackageBoarding";
import Addpackagedoctorappointment from "./components/Addpackagedoctorappointment";
import AddTrainingPackage from "./Screens/AddpackageTraining";
import RecentOrderDetailsScreen from "./components/Recentorderdetails";
import ViewSubscribers from "./components/ViewSubscribers";

// ✅ Import the PawAnimation component
import PawAnimation from "./components/PawAnimation";

// ✅ Import Firebase setup and listener
import "./firebase/firebasetest.js";
import { listenToNotifications } from "./firebaseRealtime";
import { requestForToken } from "./notificationApi";
import { listenToNotifications as listenToFcmForeground } from "./notificationApi";
import { addLocalNotification, startLocalNotificationDemo } from "./notificationApi";

function App() {
  // ✅ Start real-time Firebase notification listener once
  useEffect(() => {
    listenToNotifications();
    requestForToken();
    listenToFcmForeground();

    // Expose a simple helper for testing without API/FCM
    if (typeof window !== "undefined") {
      window.addTestNotification = (title, body) => addLocalNotification(title, body);
      // To start/stop auto demo from console:
      // const stop = startLocalNotificationDemo(10000); stop();
      window.startLocalNotificationDemo = startLocalNotificationDemo;
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/otp" element={<OTPPage />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/new-password" element={<SetNewPassword />} />
        <Route path="/success" element={<SuccessfulPage />} />
        <Route path="/pet-services" element={<PetServices />} />
        <Route path="/profile-settings" element={<ProfileSettings />} />
        <Route path="/doctors" element={<DoctorsPage />} />
        <Route path="/customer" element={<CustomerScreen />} />
        <Route path="/customer/:id" element={<CustomerDetailScreen />} />
        <Route path="/all_doctor_screen" element={<AllDoctorScreen />} />
        <Route path="/doctor_profile" element={<DoctorProfileScreen />} />
        <Route path="/add-doctor" element={<AddDoctor />} />
        <Route path="/appointment" element={<AppointmentScreen />} />
        <Route path="/appointment_detail" element={<AppointmentDetailScreen />} />
        <Route path="/subscription-plan" element={<SubscriptionPlanScreen />} />
        <Route path="/add-subscription" element={<AddSubscribtion />} />
        <Route path="/shoppers-and-shop" element={<ShoppersAndShopScreen />} />
        <Route path="/shop-details/:id" element={<ShopDetails />} />
        <Route path="/add-shop" element={<AddShopScreen />} />
        <Route path="/view-products" element={<ViewProductsScreen />} />
        <Route path="/add-product" element={<AddProductScreen />} />
        <Route path="/product-details/:shopId/:productId" element={<ProductDetails />} />
        <Route path="/booking" element={<BookingScreen />} />
        <Route path="/booking_detail" element={<BookingDetail />} />
        <Route path="/orders" element={<OrdersScreen />} />
        <Route path="/grooming" element={<GroomingScreen />} />
        <Route path="/boarding" element={<BoardingScreen />} />
        <Route path="/training" element={<TrainingScreen />} />
        <Route path="/walking" element={<WalkingScreen />} />
        <Route path="/doctor_appointment" element={<DoctorAppointmentScreen />} />
        <Route path="/diet_plan" element={<DietPlanScreen />} />
        <Route path="/add_package" element={<AddPackage />} />
        <Route path="/add_walking" element={<AddWalkingPackage />} />
        <Route path="/add_boarding" element={<AddBoardingPackage />} />
        <Route path="/add_doctorappointment" element={<Addpackagedoctorappointment />} />
        <Route path="/add_training" element={<AddTrainingPackage />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/order-details/:orderId" element={<OrderDetailsScreen />} />
        <Route path="/AppointmentDetailsScreenTwo" element={<AppointmentDetailsScreenTwo />} />
        <Route path="/recent-order-details" element={<RecentOrderDetailsScreen />} />
        <Route path="/view-subscribers" element={<ViewSubscribers />} />

        {/* ✅ New route for PawAnimation */}
        <Route path="/paw-animation" element={<PawAnimation />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router>
  );
}

export default App;
